
if (!window.Fitch) {
    window.Fitch = {
        get: function (url, type, headers, additonnalOptions) {
            var options = {
                ...this._options[type ?? 'json'], ...additonnalOptions
            };
            return this._fetch(url, {
                method: 'GET',
                headers: this._handleHeaders(options, headers)
            }, options);
        },
        post: function (url, data, type, headers, additonnalOptions) {
            var options = {
                ...this._options[type ?? 'json'], ...additonnalOptions
            };
            return this._fetch(url, {
                method: 'POST',
                headers: this._handleHeaders(options, headers),
                body: options.dataHandler.call(undefined, data)
            }, options);
        },
        put: function (url, data, type, headers, additonnalOptions) {
            var options = {
                ...this._options[type ?? 'json'], ...additonnalOptions
            };
            return this._fetch(url, {
                method: 'PUT',
                headers: this._handleHeaders(options, headers),
                body: options.dataHandler.call(undefined, data)
            }, options);
        },
        delete: function (url, data, type, headers, additonnalOptions) {
            var options = {
                ...this._options[type ?? 'json'], ...additonnalOptions
            };
            return this._fetch(url, {
                method: 'DELETE',
                headers: this._handleHeaders(options, headers),
                body: options.dataHandler.call(undefined, data)
            }, options);
        },

        _options: {
            json: {
                headers: {
                    'Accept': 'application/json, text/javascript, */*; q=0.01',
                    'Content-Type': 'application/json; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                dataHandler: data => {
                    return JSON.stringify(data);
                },
                responseHandler: data => {
                    return data.json();
                }
            },
            html: {
                headers: {
                    'Accept': 'text/html, text/javascript, */*; q=0.01',
                    'Content-Type': 'application/json; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                dataHandler: data => {
                    return JSON.stringify(data);
                },
                responseHandler: data => {
                    return data.text();
                }
            }
        },
        _fetch: function (url, request, options) {
            return fetch(url, request)
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return options.responseHandler(response);
                });
        },
        _handleHeaders: function (options, headers) {
            return { ...options.headers, ...headers };
        }
    };
}